module.exports = __webpack_public_path__ + "img/功劳木.39f2e05b.jpg";